import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { appSlice } from "../../app/appSlice";

function Alexa() {
  const dispatch = useAppDispatch();
  const spaMode = useAppSelector((state) => state.app.spaMode);
  const bubblers = useAppSelector((state) => state.app.bubblers);
  const bubblerLights = useAppSelector((state) => state.app.bubblerLights);
  const bubblerLightsColor = useAppSelector(
    (state) => state.app.bubblerLightsColor
  );
  const waterfall = useAppSelector((state) => state.app.waterfall);
  const waterfallLights = useAppSelector((state) => state.app.waterfallLights);
  const poolLights = useAppSelector((state) => state.app.poolLights);
  const poolLightsColor = useAppSelector((state) => state.app.poolLightsColor);
  const poolLightsBrightness = useAppSelector(
    (state) => state.app.poolLightsBrightness
  );
  const spaLights = useAppSelector((state) => state.app.spaLights);
  const spaLightsColor = useAppSelector((state) => state.app.spaLightsColor);
  return (
    <div className="p-5 px-10">
      <div className="my-10 flex flex-row items-center justify-center">
        <svg
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          className="block w-2/5"
          style={{ enableBackground: "new 0 0 512 512" }}
        >
          <circle
            style={{ opacity: 0.75, fill: "#FFFFFF" }}
            cx="254.9"
            cy="259.5"
            r="222"
          />
          <path
            style={{ fill: "#00CAFF" }}
            d="M254.1,67.5c-106,0.9-191.3,87.6-190.4,193.6c0.8,94.8,70.6,174.8,164.4,188.4v-39c0-11-7-21-17-24
c-70.1-23.8-107.6-99.9-83.8-170s99.9-107.6,170-83.8c56.1,19,93,72.6,90.8,131.8v1c0,1.7,0,3.3,0,5v1c0,1,0,2,0,3c0,1.3,0,2.7,0,4
v2c-18,108-159,169-160,169c8.6,1.2,17.3,1.9,26,2c106,0,192-86,192-192S360.1,67.5,254.1,67.5"
          />
        </svg>
      </div>
      <ul
        className="text-xl text-center italic"
        style={{ fontFamily: "'Literata', serif" }}
      >
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => dispatch(appSlice.actions.setPartyMode(true))}
          >
            &ldquo;Alexa, turn the pool lights to party mode&rdquo;
          </button>
        </li>
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => {
              const newVal = !(poolLights && poolLightsColor === "#E168E1");
              dispatch(appSlice.actions.setPoolLights(newVal));
              dispatch(appSlice.actions.setPoolLightsColor("#E168E1"));
              dispatch(appSlice.actions.setPoolLightsColorShow(""));
            }}
          >
            &ldquo;Alexa, set pool lights to violet&rdquo;
          </button>
        </li>
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => {
              const newVal = !(spaLights && spaLightsColor === "#FF0000");
              dispatch(appSlice.actions.setSpaLights(newVal));
              dispatch(appSlice.actions.setSpaLightsColor("#FF0000"));
              dispatch(appSlice.actions.setSpaLightsColorShow(""));
            }}
          >
            &ldquo;Alexa, turn the spa lights to ruby red&rdquo;
          </button>
        </li>
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => {
              const newVal = !(poolLights && poolLightsBrightness === 20);
              dispatch(appSlice.actions.setPoolLights(newVal));
              dispatch(appSlice.actions.setPoolLightsBrightness(20));
            }}
          >
            &ldquo;Alexa, dim pool lights to 20%&rdquo;
          </button>
        </li>
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => {
              const newVal = !(
                bubblers &&
                bubblerLights &&
                bubblerLightsColor === "#08B096"
              );
              dispatch(appSlice.actions.setBubblers(true));
              dispatch(appSlice.actions.setBubblerLights(newVal));
              dispatch(appSlice.actions.setBubblerLightsColor("#08B096"));
            }}
          >
            &ldquo;Alexa, turn the bubbler lights to emerald&rdquo;
          </button>
        </li>
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => {
              const newVal = !(waterfall && waterfallLights);
              dispatch(appSlice.actions.setWaterfall(true));
              dispatch(appSlice.actions.setWaterfallLights(newVal));
            }}
          >
            &ldquo;Alexa, turn on waterfall lights&rdquo;
          </button>
        </li>
        <li className="border-b border-gray-400">
          <button
            className="py-3"
            onClick={() => {
              dispatch(appSlice.actions.setPoolLights(false));
              dispatch(appSlice.actions.setSpaLights(false));
              dispatch(appSlice.actions.setBubblerLights(false));
              dispatch(appSlice.actions.setWaterfallLights(false));
            }}
          >
            &ldquo;Alexa, turn off all pool lights&rdquo;
          </button>
        </li>
        <li>
          <button
            className="py-3"
            onClick={() => {
              const newVal = !spaMode;
              dispatch(appSlice.actions.setSpaMode(newVal));
              dispatch(appSlice.actions.setSpaJets(newVal));
              if (newVal) {
                dispatch(appSlice.actions.setPoolMode(false));
              }
            }}
          >
            &ldquo;Alexa, turn the spa on&rdquo;
          </button>
        </li>
      </ul>
    </div>
  );
}

export default Alexa;
